export default "__VITE_ASSET__b02d4a9e__"